import { useState } from 'react';
import { messages } from '@fruitways/shared';
import { Button, Icon } from '@/components';

export interface AddVarietiesSheetProps {
  open: boolean;
  choices: string[];
  onClose: () => void;
  onAdd: (codes: string[]) => void;
}

/** Bottom sheet listing varieties not yet in the estimate. Tap to select, tap again to unselect. */
export function AddVarietiesSheet({ open, choices, onClose, onAdd }: AddVarietiesSheetProps) {
  const [pending, setPending] = useState<string[]>([]);
  if (!open) return null;

  function close() {
    setPending([]);
    onClose();
  }

  return (
    <div className="fw-scrim fw-scrim--bottom" onClick={close}>
      <div
        role="dialog"
        aria-modal="true"
        className="fw-sheet"
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 'var(--space-2)',
          }}
        >
          <span className="fw-title">{messages.addVarieties.title}</span>
          <button
            type="button"
            onClick={close}
            aria-label={messages.common.close}
            className="fw-reset-button"
            style={{
              minWidth: '44px',
              minHeight: '44px',
              display: 'grid',
              placeItems: 'center',
              color: 'var(--text-muted)',
            }}
          >
            <Icon name="close" size={24} />
          </button>
        </div>
        <span style={{ font: 'var(--type-body)', color: 'var(--text-muted)' }}>
          {messages.addVarieties.hint}
        </span>
        <div className="fw-chip-grid" style={{ maxHeight: '232px', overflowY: 'auto' }}>
          {choices.map((code) => {
            const on = pending.includes(code);
            return (
              <button
                key={code}
                type="button"
                className={`fw-chip${on ? ' fw-chip--on' : ''}`}
                aria-pressed={on}
                onClick={() =>
                  setPending((p) => (p.includes(code) ? p.filter((c) => c !== code) : [...p, code]))
                }
              >
                {code}
              </button>
            );
          })}
        </div>
        <Button
          icon="checkmark"
          disabled={pending.length === 0}
          onClick={() => {
            const codes = pending;
            setPending([]);
            onAdd(codes);
          }}
        >
          {messages.addVarieties.confirm(pending.length)}
        </Button>
      </div>
    </div>
  );
}
